import { layers } from '@atlaskit/theme/constants';
export var stickyTableHeadersIndex = 10;
export var siteSelectorIndex = stickyTableHeadersIndex + 1;
export var aboveModal = layers.modal() + 1;